import React, { useContext } from 'react';
import { SimpleAccordionContext } from './contexts';
const SimpleAccordionControls = ({ title, controls }) => {
    const { panelCount, selectPanel } = useContext(SimpleAccordionContext);
    const updateAll = (open) => Array(panelCount)
        .fill(null)
        .forEach((_, index) => selectPanel(index, open));
    const onExpand = () => updateAll(true);
    const onCollapse = () => updateAll(false);
    return !(title || controls) ? null : (React.createElement("div", { className: "cb-accordion-controls" },
        title && (React.createElement("div", { className: "cb-accordion-title" },
            React.createElement("h3", null, title))),
        controls && (React.createElement("div", { className: "cb-accordion-buttons" },
            React.createElement("button", { type: "button", className: "cb-btn cb-btn-naked cb-accordion-expand", onClick: onExpand }, "Expand All"),
            React.createElement("button", { type: "button", className: "cb-btn cb-btn-naked cb-accordion-collapse", onClick: onCollapse }, "Collapse All")))));
};
export default SimpleAccordionControls;
//# sourceMappingURL=simpleAccordionControls.js.map